<script setup>
import AppHeader from './components/app/AppHeader.vue'
import { storeToRefs } from 'pinia/dist/pinia'
import { RHDHVSnackbar } from '@haskoning/vue-component-library'
import { useDjangoAuthStore } from '@/stores/authDjango'
import { nextTick, provide, ref, watch } from 'vue'

const { user } = storeToRefs(useDjangoAuthStore())
const appbar = ref(null)
const appHeaderHeight = ref(0)
provide('appHeaderHeight', appHeaderHeight)

watch(
  () => user.value,
  async (val) => {
    if (val) {
      await nextTick()
      appHeaderHeight.value = appbar.value?.$el?.offsetHeight || 0
    }
  }
)
</script>

<template>
  <v-app>
    <AppHeader v-if="user" ref="appbar" />
    <v-main>
      <router-view />
    </v-main>
    <RHDHVSnackbar :excluded-http-methods="['GET', 'OPTIONS']" />
  </v-app>
</template>

<script></script>
<style lang="scss">
// the main file that imports everything related with styles
@use '/src/scss/settings.scss';
</style>
